import { ColumnHeightOutlined, SwapOutlined } from "@ant-design/icons";
import CustomTag from "./CustomTag";
import MachineDTO from "src/models/MachineDTO";
import React from "react";

interface MachineStatusTagProps{

    isMachineOn: boolean;
}

const MachineStatusTag : React.FC<MachineStatusTagProps> = ({ isMachineOn }) => {

    if(isMachineOn){
        return(
            <CustomTag label={'Machine: ON'} icon={<ColumnHeightOutlined />} color={'green'}/> 
        )
    }

    return(
        <CustomTag label={'Machine: OFF'} icon={<ColumnHeightOutlined />} color={'red'}/> 
    )
}

export default MachineStatusTag;